module.exports = __webpack_public_path__ + "static/media/ticket-less-parking-system.d497fb24.jpg";